
const seen = new Set<string>();

export function trackOnce(key: string): boolean {
  if (!key) return true;          // no key, no dedupe — never silently drop
  if (seen.has(key)) return false;
  seen.add(key);
  return true;
}


export function resetOnce(keyPrefix: string): void {
  if (!keyPrefix) return;
  for (const k of Array.from(seen)) {
    if (k.startsWith(keyPrefix)) seen.delete(k);
  }
}
